import React from "react";

import { withStyleProps } from "Utils/styleProps";

import CallIcon from "./Icons/ic_call.svg";
import CloseIcon from "./Icons/ic_close.svg";
import CreateIcon from "./Icons/ic_create.svg";
import DeleteIcon from "./Icons/ic_delete.svg";
import DentalIcon from "./Icons/ic_dental.svg";
import EditIcon from "./Icons/ic_edit.svg";
import InfoIcon from "./Icons/ic_info.svg";
import VisionIcon from "./Icons/ic_vision.svg";
import WarningIcon from "./Icons/ic_warning.svg";

type Props = {
  icon: string;
};

const BoltIcon = ({ icon, ...rest }: Props) => {
  switch (icon) {
    case "delete":
      return <DeleteIcon {...rest} />;
    case "info":
      return <InfoIcon {...rest} />;
    case "edit":
      return <EditIcon {...rest} />;
    case "close":
      return <CloseIcon {...rest} />;
    case "call":
      return <CallIcon {...rest} />;
    case "create":
      return <CreateIcon {...rest} />;
    case "vision":
      return <VisionIcon {...rest} />;
    case "dental":
      return <DentalIcon {...rest} />;
    case "warning":
      return <WarningIcon {...rest} />;
    default:
      return null;
  }
};

export default withStyleProps(BoltIcon);
